import {
  AdminInput,
  Button,
  Div,
  ErrorToast,
  Modal,
  SuccessToast,
  addUserBank,
  useUsers,
  reportError,
} from '@vgrubs/components';
import { useState } from 'react';

export const UserCreditCardAdd = ({ id }: { id: number | undefined }) => {
  const [customerId, setCustomerId] = useState('');
  const [fundingSourceId, setFundingSourceId] = useState('');

  const { addBankModal, setAddBankModal, setLoading } = useUsers(
    (state) => state
  );

  async function handleAddBank() {
    if (!customerId || !fundingSourceId) {
      return ErrorToast('Please fill in all information');
    }
    if (!id) {
      return ErrorToast('User ID is required');
    }

    const body = {
      customerId,
      fundingSourceId,
    };

    try {
      setLoading(true);
      const { data } = await addUserBank(id, body);
      SuccessToast(data.message);
      setAddBankModal(false);
      setCustomerId('');
      setFundingSourceId('');
    } catch (error) {
      reportError(error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <Modal
      isOpen={addBankModal}
      closeModal={() => setAddBankModal(false)}
      logo={false}
      header="Add Bank"
    >
      <Div $flex $column $gap="20px" $gapSM="16px">
        <AdminInput
          label="Customer ID"
          placeholder="Enter here"
          value={customerId}
          onChange={(e) => setCustomerId(e.target.value)}
        />
        <AdminInput
          label="Funding Source ID"
          placeholder="Enter here"
          value={fundingSourceId}
          onChange={(e) => setFundingSourceId(e.target.value)}
        />
      </Div>

      <Button $selected $w="100%" $mt="50" $mtSM="30" onClick={handleAddBank}>
        Add Bank
      </Button>
    </Modal>
  );
};
